import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { LandingComponent } from './pages/landing/landing.component';
import { MsalGuard } from '@azure/msal-angular';
import { LoginComponent } from './components/login/login.component';
import { ExploreComponent } from './pages/explore/explore.component';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { ViewContentComponent } from './pages/view-content/view-content.component';
import { VideolibraryComponent } from './pages/videolibrary/videolibrary.component';

export const routes: Routes = [
    {
        path: 'landing',
        component: LandingComponent
    },
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [MsalGuard]
    },
    {
        path:'login',
        component:LoginComponent,
        canActivate: [MsalGuard]
    },
    {   path:'explore', 
        component:ExploreComponent,
        canActivate: [MsalGuard]
    },
    {   path:'view_content', 
        component:ViewContentComponent,
        canActivate: [MsalGuard]
    },
    {   path:'video_library', 
        component:VideolibraryComponent,
        canActivate: [MsalGuard]
    },
    {
        path: '**',
        component: LandingComponent
    }
];
